import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "../../svg-icon/svg-icon";
import style from "./burger-menu-item.css";


function BurgerMenuItem({ renderText, renderChevron, href, onClickEvent }) {
    return (
        <li className={style.menuItem}>
            <a href={href} onClick={onClickEvent}>
                <div className={style.menuItemContent}>
                    <p>{renderText}</p>
                    {renderChevron && (
                        <div className={style.menuItemChevron}>
                            <SVGIcon name="chevron" />
                        </div>
                    )}
                </div>
            </a>
        </li>
    );
}

export default BurgerMenuItem;

BurgerMenuItem.propTypes = {
    renderText: PropTypes.string.isRequired,
    renderChevron: PropTypes.bool,
    href: PropTypes.string,
    onClickEvent: PropTypes.func,
};

BurgerMenuItem.defaultProps = {
    renderText: "",
    renderChevron: false,
    href: null,
};
